import axios from 'axios';
import { toast } from 'react-toastify';

// Function to create an instance of axios with a specified base URL and LoaderContext
const createAxiosInstance = (baseURL, loaderContext) => {
    const api = axios.create({
        baseURL: baseURL,
    });
    // debugger;
    // Apply the headers using an interceptor
    api.interceptors.request.use(
        (config) => {
            // Retrieve the token from sessionStorage or wherever you store it
            const token = sessionStorage.getItem('token');
            // Set the token in the headers
            // console.log("useContext", loaderContext)
            // debugger;
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            // Show the loader when a request starts
            if (loaderContext?.setLoading) {
                loaderContext.setLoading(true);
            }

            return config;
        },
        (error) => {
            if (loaderContext?.setLoading) {
                loaderContext.setLoading(false);
            }
            return Promise.reject(error);
        }
    );

    api.interceptors.response.use(
        (response) => {
            if (loaderContext?.setLoading) {
                loaderContext.setLoading(false);
            }
            return response;
        },
        (error) => {
            if (loaderContext?.setLoading) {
                loaderContext.setLoading(false);
            }
            // debugger;
            if (error.response.data.code) {
                return toast.error(error.response.data.errors);
            }
            else {
                return toast.error(error.message);
            }
        }
    );

    return api;
};

// Example usage with different base URLs
// for new prod
const api = createAxiosInstance('https://api.ciana.health/cianahealth');
const adminAPIURL = createAxiosInstance(' https://api.ciana.health/adminapi');
const labAPIURL = createAxiosInstance('https://api.ciana.health/cianalabs');
const clinicalAPIURL = createAxiosInstance('https://api.ciana.health/cianacare');
const generateReportUrl=  createAxiosInstance('https://api.ciana.health/nlpservice');
const apiInstance4 = createAxiosInstance('https://yetanotherapi.com/api');
const deleteactapis = createAxiosInstance('https://api.ciana.health/cianahealth');
const cianacareApi = createAxiosInstance('https://cianacareapi.azurewebsites.net/');


// new staging_urls
// const api = createAxiosInstance('https://staging.ciana.health/clinicapi');
// const adminAPIURL = createAxiosInstance('https://staging.ciana.health/adminapi')
// const labAPIURL = createAxiosInstance('https://staging.ciana.health/api')
// const clinicalAPIURL = createAxiosInstance('https://staging.ciana.health/clinicapi');
// const generateReportUrl = createAxiosInstance('https://staging.ciana.health/aiapi');
// const apiInstance4 = createAxiosInstance('https://yetanotherapi.com/api');
// const deleteactapis = createAxiosInstance('https://staging.ciana.health/patientapi');
// const cianacareApi = createAxiosInstance('https://staging.ciana.health/cianacareapi');

// for dev
// const api = createAxiosInstance('http://20.193.129.237:80/api/clinicapi');
// const adminAPIURL = createAxiosInstance('http://20.193.129.237:80/api/adminapi');
// const labAPIURL = createAxiosInstance('http://20.193.129.237:80/api/labapi');
// const clinicalAPIURL = createAxiosInstance('http://20.193.129.237:80/api/clinicapi');
// const generateReportUrl = createAxiosInstance('http://20.193.129.237:25688');
// const apiInstance4 = createAxiosInstance('https://yetanotherapi.com/api');
// const deleteactapis = createAxiosInstance('http://20.193.129.237:80/api');
// const cianacareApi = createAxiosInstance('http://20.193.129.237:6014/');


// Export the API instances
export { api, adminAPIURL, labAPIURL, apiInstance4, clinicalAPIURL, generateReportUrl, deleteactapis, cianacareApi };



